import type { List as GQLItem, ListTypeEnum } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The schema also exposes `errors: [String!]` on `List`; no selection has ever asked for it, so it
 * is not part of the domain type.
 */
export type List = {
  name: string;
  projected: number;
  gross: number;
  listType: ListTypeEnum;
  /** Nullable on the schema, unlike every other field here. */
  id?: number;
};

export const fromGql = (item: GQLItem): List =>
  take<List, GQLItem>(item, 'id', 'name', 'projected', 'gross', 'listType');
